import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Platform } from 'react-native';

import { Toast } from "native-base";
import {
    removeAlert
} from '../../actions/';

class Alerts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showToast: false
        };
    }

    componentDidUpdate() {
        const { alerts, dispatch } = this.props;

        alerts.forEach(alert => {
            Toast.show({
                duration: 5000,
                text: alert.message || alert.title,
                type: alert.level,
                position: Platform.OS === 'web' ? 'center' : 'bottom',
                style: { zIndex: 1000 },
                buttonText: "Закрыть",
                onClose: () => alert.id && dispatch(removeAlert(alert.id))
            });
        });

    }

    render() {
        return <></>;
    }
}

Alerts.defaultProps = {
    usePropsNotStore: false,
    alerts: []
};

Alerts.propTypes = {
    dispatch: PropTypes.func,
    alerts: PropTypes.array
};

const mapStateToProps = function (state, props) {
    return {
        // Если передан этот параметр - использовать alerts, переданные через props;
        alerts: props.usePropsNotStore ? props.alerts : state.alerts,
        alertsVisibility: state.alertsVisibility
    };
};

export default connect(mapStateToProps)((Alerts));
